import type { ComboboxOptions } from "@simplybusiness/mobius";
import type { Trade, TradeOption } from "./types";

export const groupResults = (
  results: Trade[],
): ComboboxOptions<TradeOption> => {
  const mapped = results.map(
    ({ value, vertical, definition }) =>
      ({
        label: value,
        value,
        vertical,
        definition,
      }) as const,
  );

  // Group results using reduce instead of multiple filter operations
  const { exact, suggested } = results.reduce(
    (
      groups: { exact: typeof mapped; suggested: typeof mapped },
      result,
      index,
    ) => {
      if (result.type === "exact") {
        groups.exact.push(mapped[index]);
      } else if (result.type === "suggested") {
        groups.suggested.push(mapped[index]);
      }
      return groups;
    },
    { exact: [], suggested: [] },
  );

  if (!suggested.length || !exact.length) {
    return mapped;
  }

  return [
    {
      heading: "Exact",
      options: exact,
    },
    {
      heading: "Suggested",
      options: suggested,
    },
  ];
};
